import React from 'react';
import Link from 'next/link';
import PropertyCard, { PropertyCardData } from '@/components/PropertyCard';
import { ArrowRight } from 'lucide-react';

const SIMILAR_PROPERTIES: PropertyCardData[] = [
{
  id: 'sim-001',
  title: 'Fenerbahçe\'de 3+1 Deniz Manzaralı',
  price: '₺11.200.000',
  pricePerM2: '₺80.000',
  location: 'Fenerbahçe Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 140,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a34910e4-1784087343847.png",
  imageAlt: 'Fenerbahçe daire salon ve deniz manzarası',
  badges: ['dogrulanmis'],
  views: 2890,
  daysListed: 6,
  rentalYield: '5.9',
  investmentScore: 78
},
{
  id: 'sim-002',
  title: 'Moda\'da 2+1 Yenilenmiş Daire',
  price: '₺8.500.000',
  pricePerM2: '₺94.444',
  location: 'Moda Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 2,
  bathrooms: 1,
  area: 90,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17f314956-1772392432673.png",
  imageAlt: 'Yenilenmiş daire, modern iç tasarım, parke zemin',
  badges: ['yeni', 'dogrulanmis'],
  views: 1654,
  daysListed: 2,
  rentalYield: '6.3',
  investmentScore: 81
},
{
  id: 'sim-003',
  title: 'Caddebostan\'da 3+1 Rezidans',
  price: '₺13.900.000',
  pricePerM2: '₺86.875',
  location: 'Caddebostan Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 160,
  type: 'Rezidans',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17efc6ebc-1773268075370.png",
  imageAlt: 'Rezidans daire, yüksek tavan, şehir manzarası',
  badges: ['one-cikan', '3d'],
  views: 4120,
  daysListed: 8,
  rentalYield: '5.2',
  investmentScore: 74
},
{
  id: 'sim-004',
  title: 'Suadiye\'de 3+1 Site İçi Daire',
  price: '₺10.800.000',
  pricePerM2: '₺77.142',
  location: 'Suadiye Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 140,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c063d493-1777501245181.png",
  imageAlt: 'Site içi daire, havuz manzarası, güneşli balkon',
  badges: ['fiyat-dustu', 'dogrulanmis'],
  views: 3201,
  daysListed: 19,
  rentalYield: '6.0',
  investmentScore: 76
}];


export default function SimilarProperties() {
  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-lg font-bold text-foreground">Benzer İlanlar</h3>
          <p className="text-sm text-muted-foreground mt-0.5">Bu ilana benzer 14 ilan bulundu</p>
        </div>
        <Link href="/property-search?ilce=kadikoy&oda=3&tip=satilik" className="flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline">
          Tümünü Gör <ArrowRight size={14} />
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {SIMILAR_PROPERTIES.map((property) =>
        <PropertyCard key={property.id} property={property} variant="grid" />
        )}
      </div>
    </div>);

}